// extracted by mini-css-extract-plugin
module.exports = {"container":"MandarakePromotionBanner_container__cuz_c"};